import { render, staticRenderFns } from "./CallLogs.vue?vue&type=template&id=29fde84c&scoped=true&"
import script from "./CallLogs.vue?vue&type=script&lang=js&"
export * from "./CallLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fde84c",
  null
  
)

export default component.exports